module.exports = __webpack_public_path__ + "img/course_video.12b0b5d3.png";